export default "__VITE_ASSET__db07bc65__"